<template>
  <div class="result_layer fx fdc">
    <div class="logo_frame _fill">
      <div class="logo"><img src="@img/logo_bg_gray.svg" alt=""></div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
    <div v-if="submit" class="wv_button">
      <div class="main_btn _main" @click="submit">確認</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    submit: Function
  }
}
</script>

<style lang="scss" scoped>
.result_layer {
  flex-shrink: 1;
  height: 100%;
}
</style>